export default {
  "242290" : {
    title: "科博会智能服务",
    subTitle: "CHITEC",
    onboardingTitle: "您可以向我咨询科博会相关信息"
  },
  "244043": {
    title: "SIAL智能服务",
    subTitle: "SIAL Shanghai 2025",
    onboardingTitle: "您可以向我咨询SIAL相关信息"
  },
  "111111": {
    title: "TRS智能服务",
    subTitle: "TRS",
    onboardingTitle: "您可以向我咨询TRS系统相关信息"
  },
  "472859": {
    title: "E展通智能服务",
    subTitle: "E展通",
    onboardingTitle: "您可以向我咨询E展通相关信息"
  }
}
